import React, { useCallback } from 'react'

import { Button } from '@collaborate-health/uikit'
import { Step } from '../../types'

interface StepperNavigationProps {
  activeStep: Step
  stepsCount: number
  isNextStepDisabled: boolean
  setActiveStep: (step: Step | ((prevStep: Step) => Step)) => void
  onClose: () => void
  onCreate: () => void
}

const StepperNavigation: React.FC<StepperNavigationProps> = ({
  activeStep,
  stepsCount,
  setActiveStep,
  onClose,
  onCreate,
  isNextStepDisabled,
}) => {
  const handleBack = useCallback(() => {
    setActiveStep((prev) => {
      const newOrder = prev.Order - 1
      return newOrder >= 0 ? { ...prev, Order: newOrder } : prev
    })
  }, [setActiveStep])

  const handleNext = useCallback(() => {
    setActiveStep((prev) => {
      const newOrder = prev.Order + 1
      return newOrder < stepsCount ? { ...prev, Order: newOrder } : prev
    })
  }, [setActiveStep, stepsCount])

  const isFirstStep = activeStep.Order === 0
  const isLastStep = activeStep.Order === stepsCount - 1

  return (
    <>
      <Button size='small' onClick={isFirstStep ? onClose : handleBack}>
        {isFirstStep ? 'Close' : 'Back'}
      </Button>
      <Button
        variant='contained'
        color='primary'
        size='small'
        onClick={isLastStep ? onCreate : handleNext}
        disabled={isNextStepDisabled}
      >
        {isLastStep ? 'Create' : 'Next'}
      </Button>
    </>
  )
}

export default StepperNavigation

